import type { RootState } from '@/store';

const selectOnboardingSelf = (state: RootState) => state.onboardingSelf;

export const selectOnboardingSelfStep = (state: RootState) => selectOnboardingSelf(state).step;
export const selectOnboardingSelfEmpresa = (state: RootState) =>
  selectOnboardingSelf(state).empresa;
export const selectOnboardingSelfRazaoSocialReceita = (state: RootState) =>
  selectOnboardingSelf(state).razaoSocialReceita;
export const selectOnboardingSelfCnpjStatus = (state: RootState) =>
  selectOnboardingSelf(state).cnpjStatus;
export const selectOnboardingSelfTermosVersao = (state: RootState) =>
  selectOnboardingSelf(state).termosVersao;
export const selectOnboardingSelfTermosVersaoAceita = (state: RootState) =>
  selectOnboardingSelf(state).termosVersaoAceita;
export const selectOnboardingSelfTermosStatus = (state: RootState) =>
  selectOnboardingSelf(state).termosStatus;
export const selectOnboardingSelfProdutos = (state: RootState) =>
  selectOnboardingSelf(state).produtos;
export const selectOnboardingSelfVolume = (state: RootState) => selectOnboardingSelf(state).volume;
export const selectOnboardingSelfCanal = (state: RootState) => selectOnboardingSelf(state).canal;
export const selectOnboardingSelfCriandoConta = (state: RootState) =>
  selectOnboardingSelf(state).criandoConta;
export const selectOnboardingSelfIncluirRespostas = (state: RootState) =>
  selectOnboardingSelf(state).incluirRespostasDaOperacao;
export const selectOnboardingSelfCriarContaErro = (state: RootState) =>
  selectOnboardingSelf(state).criarContaErro;
export const selectOnboardingSelfConta = (state: RootState) => selectOnboardingSelf(state).conta;
export const selectOnboardingSelfSaldoPresente = (state: RootState) =>
  selectOnboardingSelf(state).conta?.saldoPresente ?? null;
export const selectOnboardingSelfAvisoNotificado = (state: RootState) =>
  selectOnboardingSelf(state).avisoNotificadoAberto;
export const selectOnboardingSelfRascunhoHidratado = (state: RootState) =>
  selectOnboardingSelf(state).rascunhoHidratado;
